// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__j81Y3","active":"NavLink_active__NgRPb"};